import { masks } from "@core/utils/masks";
import { z } from "zod";

export const agreementPlanSchema = () => {
  return z.object({
    name: z.string().min(1),
    type: z.string().optional().nullable(),
    level: z.number().optional().nullable(),
    uuid: z.string().optional().nullable(),
    access_amount: z.number().optional().nullable(),
    value: z.string().min(1).transform((val) => Number(masks.unmask(val))),
    vindi_page: z.string().optional().nullable(),
    vindi_token: z.string().optional().nullable(),
    for_agreement: z.number().optional().nullable(),
    slug: z.string().optional().nullable(),
  });
};

export type AgreementPlanFormValues = z.infer<ReturnType<typeof agreementPlanSchema>>;
